import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  Box,
  Flex,
  Textarea,
  Icon,
} from "@chakra-ui/react";
import { FiSave, FiGitBranch } from "react-icons/fi";
import { RiSave3Line } from "react-icons/ri";

const SaveConfirmationModal = ({
  isOpen,
  onClose,
  onUpdate,
  onSaveAsNew,
  currentVersion = 1,
  latestVersion = currentVersion,
}) => {
  const nextVersion = (latestVersion || currentVersion) + 1;
  const [saveAction, setSaveAction] = useState("new");
  const [notes, setNotes] = useState("");

  const handleSave = () => {
    if (saveAction === "new") {
      onSaveAsNew(notes);
    } else {
      onUpdate(notes);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="md">
      <ModalOverlay />
      <ModalContent borderRadius="xl">
        <ModalHeader display="flex" alignItems="center" gap={2}>
          <Icon as={RiSave3Line} color="teal.500" boxSize={6} />
          Save Conceptual Mood Board
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={2}>
          <Text color="gray.500" mb={6}>
            Save as a new version or update the current one.
          </Text>

          <Text fontWeight="medium" mb={3}>
            Save action
          </Text>
          <Flex gap={4} mb={6}>
            {/* New Version Option */}
            <Box
              flex={1}
              border="2px solid"
              borderColor={saveAction === "new" ? "teal.500" : "gray.200"}
              bg={saveAction === "new" ? "teal.50" : "white"}
              borderRadius="lg"
              p={4}
              cursor="pointer"
              onClick={() => setSaveAction("new")}
              textAlign="center"
              transition="all 0.2s"
            >
              <Icon
                as={FiGitBranch}
                boxSize={6}
                color={saveAction === "new" ? "teal.500" : "gray.600"}
                mb={2}
              />
              <Text
                fontWeight="semibold"
                color={saveAction === "new" ? "teal.600" : "gray.700"}
              >
                New Version
              </Text>
              <Text fontSize="sm" color="gray.500">
                Save as V{nextVersion}
              </Text>
            </Box>

            {/* Update Option */}
            <Box
              flex={1}
              border="2px solid"
              borderColor={saveAction === "update" ? "teal.500" : "gray.200"}
              bg={saveAction === "update" ? "teal.50" : "white"}
              borderRadius="lg"
              p={4}
              cursor="pointer"
              onClick={() => setSaveAction("update")}
              textAlign="center"
              transition="all 0.2s"
            >
              <Icon
                as={FiSave}
                boxSize={6}
                color={saveAction === "update" ? "teal.500" : "gray.600"}
                mb={2}
              />
              <Text
                fontWeight="semibold"
                color={saveAction === "update" ? "teal.600" : "gray.700"}
              >
                Update V{currentVersion}
              </Text>
              <Text fontSize="sm" color="gray.500">
                Overwrite current
              </Text>
            </Box>
          </Flex>

          <Text fontWeight="medium" mb={2}>
            Notes{" "}
            <Text as="span" color="gray.400" fontWeight="normal">
              (optional)
            </Text>
          </Text>
          <Textarea
            placeholder="e.g. Updated images for reception area..."
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows={3}
            resize="none"
          />
        </ModalBody>

        <ModalFooter gap={3}>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="teal" onClick={handleSave}>
            {saveAction === "new"
              ? `Save as V${nextVersion}`
              : `Update V${currentVersion}`}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SaveConfirmationModal;
